import { LinkButton } from '@/components/ui/link-button';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import useIsMobile from '@/hooks/use-is-mobile';

const MobileAddToCartSuccessTip = ({
  addToCartQty,
  addToCartStatus,
}: {
  addToCartQty: number;
  addToCartStatus: boolean;
}) => {
  const isMobile = useIsMobile();

  if (!isMobile) {
    return null;
  }

  return (
    <Sheet open={addToCartStatus}>
      <SheetContent
        side={'top'}
        showCloseButton={false}
        className='top-[86px]'
        maskClassName='top-[86px]'
      >
        <p className='pb-[15px] text-center'>{addToCartQty} item added to your cart</p>
        <LinkButton
          href='/checkout'
          className='h-[40px] rounded-[3px] font-jost text-[15px] font-medium'
        >
          CHECKOUT
        </LinkButton>
      </SheetContent>
    </Sheet>
  );
};

export default MobileAddToCartSuccessTip;
